const lengthToTimeMap = {
  Burst: 7,
  Short: 15,
  Medium: 30,
  Long: 45,
};

const timeToLengthMap = Object.entries(lengthToTimeMap).reduce((acc, [length, time]) => {
  acc[time] = length;
  return acc;
}, {});

export { lengthToTimeMap, timeToLengthMap };
